module.exports = __webpack_public_path__ + "img/Icon_Instagram.1969a38a.svg";